import React, { useContext, useState, useEffect } from "react";
import globalComp from "../../../global/components";
import textTools from "./TextTools";
import { ProductContext, CanvasContext, ModuleContext } from "../provider";
import ff, { commonStyle } from "../../../util/fabric";
let config = require("../../../../appConfig.json");

let moduleVariation = {
  kids: ["girl", "boy"],
  apeMaia: ["girl", "boy", "unisex"],
  vintage: ["paris", "venice", "africa"],
};

function ImagesPresets_Prd() {
  let t = window.INITIAL_DATA.TRANSLATIONS;
  const {
    productVariation,
    productType,
    setProductVariation,
    printPaper,
  } = useContext(ProductContext);
  const {
    moduleImages,
    setModuleImages,
    moduleInfo,
    setModuleInfo,
    setAreGridLinesEnabled,
  } = useContext(ModuleContext);
  const { canvasRef, scaledCanvasSize, canvasResizeCoef } = useContext(
    CanvasContext
  );

  const [productVariationCheckboxes, setProductVariationCheckboxes] = useState<
    any
  >(null);
  const [quote, setQuote] = useState<string>(t.kids_module_default_quote);

  useEffect(() => {
    setModuleInfo({
      ...moduleInfo,
      ...commonStyle,
      fontFamily:
        window.INITIAL_DATA.LANGUAGE == "ru"
          ? config.cyrillicFonts[0]
          : config.latinFonts[0],
      preset: {},
    });
  }, []);

  // to initialize kids variation
  useEffect(() => {
    if (productType) {
      if (productType === "kids") {
        setProductVariation(moduleVariation.kids[0]);
      }
      if (productType === "ape-maia") {
        setProductVariation(moduleVariation.apeMaia[0]);
      }
      if (productType === "vintage") {
        setProductVariation(moduleVariation.vintage[0]);
      }
    }
  }, [productType]);

  // to set images
  useEffect(() => {
    let url = "https://storage.googleapis.com/papername-bucket";
    if (productVariation && productType) {
      let image = [];
      let prefix;

      if (productType === "kids") {
        if (productVariation === "boy") {
          prefix = "boys_preset";
        } else if (productVariation === "girl") {
          prefix = "girls_preset";
        }
      }

      if (productType === "ape-maia") {
        if (productVariation === "boy") {
          prefix = "ape_maia_boys";
        } else if (productVariation === "girl") {
          prefix = "ape_maia_girls";
        } else if (productVariation === "unisex") {
          prefix = "ape_maia_unisex";
        }
      }

      if (productType === "vintage") {
        if (productVariation === "africa") {
          prefix = "vintage_africa";
        } else if (productVariation === "paris") {
          prefix = "vintage_paris";
        } else if (productVariation === "cinema") {
          prefix = "vintage_cinema";
        } else if (productVariation === "venice") {
          prefix = "vintage_venice";
        }
      }

      if (prefix) {
        for (let i = 1; i < 9; i++) {
          let tempUrl = `${url}/presets/${prefix}/${prefix}_${i}${
            productType === "kids" ? ".png" : ".jpg"
          }`;

          image.push({
            id: `image-${i}`,
            originalUrl: tempUrl,
            filteredUrl: tempUrl,
            croppedUrl: tempUrl,
            renderUrl: tempUrl,
          });
        }
        setModuleImages([...image]);
      }

      makeProductVariationCheckboxes(productType);
    }
  }, [productVariation]);

  // to update background
  useEffect(() => {
    if (moduleInfo && canvasRef.current) {
      canvasRef.current.getObjects().forEach(function(object) {
        // NOTE: arbitrary id, DO NOT CHANGE
        //@ts-ignore
        if (object.id === "kids-background-4") {
          object.set({
            fill: moduleInfo.bgColor,
          });
        }
      });
    }
  }, [scaledCanvasSize, moduleInfo]);

  // to update images
  useEffect(() => {
    if (moduleImages && canvasRef.current) {
      ff.handleImageOnly_ImageChange(
        moduleImages,
        canvasRef.current,
        false,
        ff.cmToPx(0.3, printPaper.dpi) * canvasResizeCoef,
        false,
        {
          selectable: false,
        },
        [4],
        ["textbox"],
        true
      );
      setAreGridLinesEnabled(true);
      // @ts-ignore
      canvasRef.current.set({
        padding: ff.cmToPx(0.3, printPaper.dpi) * canvasResizeCoef,
      });
    }
  }, [moduleImages, scaledCanvasSize]);

  // to mount text
  useEffect(() => {
    if (canvasRef.current && scaledCanvasSize) {
      ff.addTextForKids(
        canvasRef.current,
        quote,
        moduleInfo.textColor,
        scaledCanvasSize.width,
        scaledCanvasSize.height
      );
    }
  }, [canvasRef.current, scaledCanvasSize]);

  // to update text of kids
  useEffect(() => {
    if (canvasRef.current && moduleInfo)
      ff.handleTextForKids(canvasRef.current, quote, moduleInfo.textColor);
  }, [quote, moduleInfo]);

  function handleQuoteChange(word: string) {
    if (
      (word.length < 60 &&
        word.match(/^[^\udf00-\udfff\udc00-\ude4f\ude80-\udeff]+$/)) ||
      word == ""
    ) {
      setQuote(ff.wordBreak(word, 20));
    }
  }

  function makeProductVariationCheckboxes(productType: string) {
    if (productType === "kids") {
      setProductVariationCheckboxes([
        {
          radioLabelStr: t.girls,
          name: "preset-type-input",
          id: "girl-preset-input",
          checked: productVariation === "girl",
          onChange: () => setProductVariation("girl"),
        },
        {
          radioLabelStr: t.boys,
          name: "preset-type-input",
          id: "boy-preset-input",
          checked: productVariation === "boy",
          onChange: () => setProductVariation("boy"),
        },
      ]);
    } else if (productType === "ape-maia") {
      setProductVariationCheckboxes([
        {
          radioLabelStr: t.girls,
          name: "preset-type-input",
          id: "girl-preset-input",
          checked: productVariation === "girl",
          onChange: () => setProductVariation("girl"),
        },
        {
          radioLabelStr: t.boys,
          name: "preset-type-input",
          id: "boy-preset-input",
          checked: productVariation === "boy",
          onChange: () => setProductVariation("boy"),
        },
        {
          radioLabelStr: t.unisex,
          name: "preset-type-input",
          id: "unisex-preset-input",
          checked: productVariation === "unisex",
          onChange: () => setProductVariation("unisex"),
        },
      ]);
    } else if (productType === "vintage") {
      setProductVariationCheckboxes([
        {
          radioLabelStr: t.paris,
          name: "preset-type-input",
          id: "paris-preset-input",
          checked: productVariation === "paris",
          onChange: () => setProductVariation("paris"),
        },
        {
          radioLabelStr: t.venice,
          name: "preset-type-input",
          id: "venice-preset-input",
          checked: productVariation === "venice",
          onChange: () => setProductVariation("venice"),
        },
        {
          radioLabelStr: t.africa,
          name: "preset-type-input",
          id: "africa-preset-input",
          checked: productVariation === "africa",
          onChange: () => setProductVariation("africa"),
        },
        // {
        //   radioLabelStr: t.cinema,
        //   name: "preset-type-input",
        //   id: "cinema-preset-input",
        //   checked: productVariation === "cinema",
        //   onChange: () => setProductVariation("cinema"),
        // },
      ]);
    }
  }

  return (
    <>
      {productVariationCheckboxes && (
        <globalComp.RadioBox
          number={1}
          labelStr={t.select_model}
          tooltipStr={t.tooltip_kids_gender}
          type={"default"}
          inputs={[...productVariationCheckboxes]}
        />
      )}
      <textTools.ColorCombination
        number={2}
        radioGroupName={"color-preset-input"}
      />
      <textTools.FontFamily number={3} />
      <globalComp.TextBox
        number={4}
        labelStr={t.enter_your_quote}
        tooltipStr={t.tooltip_enter_your_quote}
        placeholderStr={t.enter_your_quote_placeholder}
        type={"textarea"}
        onChange={(event) => {
          // @ts-ignore
          handleQuoteChange(event.target.value);
        }}
        onFocus={(event) => {
          if (event.target.value == t.kids_module_default_quote) {
            event.target.value = "";
          }
        }}
        value={quote}
        maxStrLength={60}
      />
    </>
  );
}

export default ImagesPresets_Prd;
